import { DesignFilesAction } from 'app/core/enums';
import type { OrderDesignAction } from 'app/core/models';

/** Returns whether any currently represented design action is an active redesign revision. */
export function isRedesignedOrder(designActions: readonly Pick<OrderDesignAction, 'action' | 'isRedesign'>[]): boolean {
  return designActions.some(
    designAction => designAction.action === DesignFilesAction.Revision && designAction.isRedesign
  );
}
